import { customElement, property, state } from 'lit/decorators.js'
import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { consume } from '@lit/context'
import { productTileProductContext } from 'components/discovery/product/tile-parts/tile-product-context.js'
import { InternalProduct, ProductModel } from 'components/discovery/product/tile-parts/tile-parts-typing.js'
import { partsStyle } from 'components/discovery/product/tile-parts/tile-parts.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { hasVariants } from 'components/shared/variants/variant-grouping.js'


initializeIconsByRole({
  'csc-product-tile-variant-indication.icon': { name: 'circle-info', style: 'solid' },
})

export const badgeVariants = ['default', 'error', 'info', 'success', 'warning', 'new', 'our-choice', 'bestseller', 'sale', 'premium'] as const
export type badgeVariantTypes = typeof badgeVariants

@customElement('csc-product-tile-variant-indication')
export class CSCProductTileVariantIndication extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, partsStyle]

  @consume({ context: productTileProductContext })
  @state()
  product: InternalProduct = new ProductModel().parseToInternal()

  @property({ type: String, attribute: 'badge-variant' })
  badgeVariant: badgeVariantTypes[number] = 'info'

  override render() {
    if (!hasVariants(this.product)) return nothing

    return html`
      <cse-link url="${this.product.pageLink}">
        <cse-badge variant="${this.badgeVariant}" composition="simple" class="csc-product-tile-variant-indication">
          <cse-icon slot="prefix" icon-role="csc-product-tile-variant-indication.icon"></cse-icon>
          ${t('variant_indication', { ns: 'csc-product-tile', default: 'Variants available' })}
        </cse-badge>
      </cse-link>
    `
  }
}
